import {
  DeliveryIcon,
  ServiceIcon,
  MotionSensorIcon,
  VisitorIcon,
  VehicleOutlineIcon,
  DisarmHomeIcon,
  MonitoringStationIcon,
  MedicalIcon,
  FireDepartmentIcon,
  CheckIcon,
  AnimalIcon,
} from '@ring-icons';

const eventsToIconsMap = {
  Passerby: {
    displayName: 'Passerby',
    icon: MotionSensorIcon,
    description:
      'Guards determined the motion event was from a person but they did not enter the property.  Adjust your motion zones if you are getting false alarms.',
  },
  UnknownPerson: {
    displayName: 'Unknown Person',
    icon: VisitorIcon,
    description: 'An unknown person was detected on the property but they left after a Guard warning.',
  },
  /*
   * Removing as per product request. See https://jira.atl.ring.com/browse/HOP-6518
  RequireAttention: {
    displayName: 'Suspicious',
    icon: StrangerIcon,
    description:
      'An unknown person was detected on the property and they either did not leave after a Guard warning or exhibited malicious behavior.',
  },
  */
  Delivery: {
    displayName: 'Delivery',
    icon: DeliveryIcon,
    description: 'A delivery person was seen on the property.',
  },
  Service: {
    displayName: 'Service Worker',
    icon: ServiceIcon,
    description: 'A service worker was seen on the property.',
  },
  Vehicle: {
    displayName: 'Vehicle',
    icon: VehicleOutlineIcon,
    description: 'Guards determined the motion event was from a vehicle.',
  },
  Animal: {
    displayName: 'Animal',
    icon: AnimalIcon,
    description: 'Guards determined the motion event was from an animal.',
  },
  AlarmResolved: {
    displayName: 'Disarmed',
    icon: DisarmHomeIcon,
    description: 'Guards reviewed a motion event but the service was disarmed.',
  },
  Police: {
    displayName: 'Police Emergency',
    icon: MonitoringStationIcon,
    isEmergency: true,
    description: 'Guards dispatched Police for an emergency.',
  },
  Medical: {
    displayName: 'Medical Emergency',
    icon: MedicalIcon,
    isEmergency: true,
    description: 'Guards dispatched Medical services for an emergency.',
  },
  Fire: {
    displayName: 'Fire Emergency',
    icon: FireDepartmentIcon,
    isEmergency: true,
    description: 'Guards dispatched Fire Department for an emergency.',
  },
};

export const GUARD_REVIEWED_EVENT_TYPE = 'GuardReviewed'

export const guardReviewed = {
  displayName: 'Guard Reviewed',
  key: GUARD_REVIEWED_EVENT_TYPE,
  icon: CheckIcon,
  description: 'Events reviewed by Guards.',
};

export default eventsToIconsMap;
